import { getSlugFromContentSubject } from "app/content-subjects/slug"
import { ContentSubjectType } from "db/enums"

export type LearningLinePageLinkProps = {
  learningLineTheme: {
    learningLine: {
      slug: string
      contentSubject: ContentSubjectType
    } | null
    slug: string
  } | null
  slug: string
}

export default function getLearningLineLinkProps(
  learningLine: LearningLinePageLinkProps
) {
  if (!learningLine?.learningLineTheme?.learningLine) {
    return {
      href: "#",
    }
  }
  const learningLineSlug = learningLine.learningLineTheme.learningLine.slug
  const vakSlug = getSlugFromContentSubject(
    learningLine.learningLineTheme.learningLine.contentSubject
  )
  const themeSlug = learningLine.learningLineTheme.slug
  const nameSlug = learningLine.slug
  return {
    href: `/leerlijn/${vakSlug}/${learningLineSlug}/${themeSlug}/${nameSlug}`,
  }
}
